import { Checkbox } from "@mui/material";
import {
    HTMLAttributes,
    useState,
     ReactElement,
     useCallback,
     MouseEvent,
     useEffect,
     useRef
} from "react";
import { DangerSquare } from "../../assets";

interface Props extends HTMLAttributes<HTMLElement> {
    value?: any;
    title?: string,
    onChange?: any;
    myStyle?: string;
    lable?: string;
    displayEmpty?: boolean;
    placeholder?: string;
    icon?: ReactElement;
    iconBorder?: boolean;
    hasNotice?: boolean;
    item?: any;
    isRequired?: boolean;
    disabled?:boolean;
    contentLoading?: boolean;

}
const label = { inputProps: { 'aria-label': 'Checkbox demo' } };

export function CustomSelect({ value, onChange, title, myStyle, disabled, displayEmpty, placeholder, icon, iconBorder, hasNotice, isRequired, onClick, item , contentLoading}: Props): ReactElement {
    const ref :any = useRef(null);
    const [showDropDown, setShowDropDown] = useState(false);

    const handleOnClick = (item:any) => {

        if( !disabled){
            onChange && onChange(item);
            setShowDropDown(false)

        }
    }


    useEffect(() => {
        const checkIfClickedOutside = (e: { target: any; }) => {   
          if (showDropDown && ref.current && !ref.current.contains(e.target)) {
            setShowDropDown(false)
          }
        }
        document.addEventListener("mousedown", checkIfClickedOutside)
    
        return () => {
          document.removeEventListener("mousedown", checkIfClickedOutside)
        }
      }, [showDropDown])

    return (
        <div className={`${myStyle && myStyle} ${value === undefined ? "" : "checked"} custom-select`} ref={ref}>

{contentLoading ?
                        <div className="w-100 content-loading input-loading-lable">
                        </div>
                        :
 <>
 
 <div className="custom-select-content"  onClick={() => disabled === true ? null : setShowDropDown(true) } >
                <div >
                    <span className={`${disabled ? "disabled" : ""} custom-select-placeholder`}>
                        {placeholder}
                    </span>
                    {hasNotice && !value &&
                        <img src={DangerSquare} alt="هامرز"/>
                    }
                </div>
                <div className="d-flex align-items-center">
                        <span className={`${disabled ? "disabled" : ""} custom-select-placeholder custom-select-selected ps-2`}>
                           {item?.type === "boolean" ?
                          <>
                           {value === true ?  "بله" : "خیر"}

                          </>
                        :
                       <>
                        {value} 
                       </>
                        
                        }
                        </span>
                    <div className="arrow arrow-up"></div>
                </div>
            </div>
            {showDropDown === true ? (
                <ul className="custom-select-list">
                    {item?.type === "boolean" ?
                        <>
                           <li className="custom-select-list-item" onClick={() => handleOnClick(true)}>
                                 <a> بله</a>
                             </li>
                             <li className="custom-select-list-item" onClick={() => handleOnClick(false)}>
                                 <a> خیر</a>
                             </li>
                        </>
                        :
                        <>
                            {item?.values && item?.values?.map((item: any, index: any) => (
                               
                                 <li key={index} className="custom-select-list-item" onClick={() => handleOnClick(item)}>
                                 <a> {item}</a>
                             </li>
                            ))}
                        </>
                    }
                </ul >
            ) : (null)
            }
            {/* {showDropDown ? (<div className='overlay' onClick={() => setShowDropDown(false)} />) : null} */}
 </>           

}
        </div >
    );
}

export default CustomSelect;

